// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';
import {Center} from '../interfaces';

type Props = {
  getData: any;
  data: Center[];
  id: string | number;
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {


  const handleCreateCSV = () => {
    props.getData({
      ...props.filtersValues,
      size: 10000,
      'partnerId.equals': props.id,
    });
  };

  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {...item};
    });

    return newData;
  };

  return (
    <>
      {props.data.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="Centers.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
